<script>
	// import components
	import Nav from './components/Nav.svelte'
	import Home from './components/Home.svelte'
	import Realisations from './components/Projects.svelte'
	import Inside from './components/Inside.svelte';
	import Outside from './components/Outside.svelte';
	import Contact from './components/Contact.svelte';
	import Footer from './components/Footer.svelte';

	let page = 'Home'

	function handleMessage(event){
		page = event.detail.text
	}


</script>

<main>
	
	<Nav on:message={handleMessage}/>

	{#if page === 'Home'}
		<Home/>
	{:else if page === 'Realisations'}
		<Realisations/>
	{:else if page === 'Inside'}
		<Inside/>
	{:else if page === 'Outside'}
		<Outside/>
	{:else if page === 'Contact'}
		<Contact/>
	{/if}

	<Footer/>

</main>

<style>
	
</style>